import { writable } from "svelte/store"

const defaultSearch = {
  accountNumber: "",
  firstName: "",
  lastName: "",
  login: "",
  phoneNumber: "",
  taxNumber: "",
}

const store = writable(structuredClone(defaultSearch))

export const searchStore = {
  ...store,
  reset: () => store.set(structuredClone(defaultSearch)),
}
